import axios from 'axios';
import { postRequest } from 'utils/httpServices';

const externalAxios = axios.create({
  baseURL: 'https://api.postalpincode.in/pincode/'
});

class utilsAPI {
  static getPincode = (queryData = {}, config = {}) => {
    return externalAxios
      .request({
        url: `${queryData.id}`,
        method: 'get',
        headers: config.headers
      })
      .catch(() => ({ success: false, data: 'Something went wrong', status: 500 }));
  };

  static partnerExternalEntity = (queryData = {}, config = {}) => {
    return postRequest(`v1/call-external-partner-entity`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      satus: (error.response && error.response.status) || 400
    }));
  };
}

export default utilsAPI;
